import React from 'react';

export const Project = ({mypost})=>{
    var color = "purple"
    return (
  	<>
    <div className="card mb-0 my-0 ">  
    <div className="card-body">
    <h5 className="card-title">{mypost.title} <span className = {`badge rounded-pill bg-${color}`}>{mypost.category}</span></h5>

    <p className="card-text">
    {mypost.content}
    </p>
    <a href={mypost.link} className="float-left sbtn next-arrow-btn green-btn mx-2" target="_blank">
    View Project
    </a>
    <a href={mypost.git} className="float-right sbtn next-arrow-btn black-btn" target="_blank">
    Source Code
    </a>
    </div>
    </div>
    <br/>
  	</>
)}